import { Component } from '@angular/core';

@Component({
    selector: 'app-asistencia-incidencia',
    templateUrl: './asistencia-incidencia.component.html',
    styleUrls: ['./asistencia-incidencia.component.scss'],
    standalone: false
})
export class AsistenciaIncidenciaComponent  {

 

}
